import { Collapse } from '@material-ui/core';

const TRANSITION_TIMEOUT: number = 1000

const TransitionCollapse: React.FC<{ show: boolean }> = ({ show, children }) => {
    return <Collapse in={show} timeout={TRANSITION_TIMEOUT} unmountOnExit style={{ width: '100%' }} >
        {children}
    </Collapse >

}

export default TransitionCollapse;